import isEmpty from "lodash/isEmpty"
import { ceil } from "lodash"
export default {
  created() {
    this.$events.$on("searched", this.setUrl)
  },
  unmounted() {
    this.$events.$off("searched", this.setUrl)
    window.removeEventListener("popstate", this.setSelected)
  },
  computed: {
    totalPages() {
      return ceil(this.results.pagination.total / this.per_page)
    },
  },
  methods: {
    bindNavigation() {
      window.removeEventListener("popstate", this.setSelected)
      window.addEventListener("popstate", this.setSelected)

      if (!isEmpty(window.capes[this.name].filters)) {
        this.filters = { ...this.filters, ...window.capes[this.name].filters }
      }

      if (!isEmpty(window.capes[this.name].order)) {
        this.order = window.capes[this.name].order
      }
    },
    setUrl() {
      let query = {
        capes_categories: typeof this.filters.categories !== "undefined" ? this.filters.categories.join("|") : false,
        capes_order: typeof this.order !== "undefined" ? this.order : false,
        capes_page: typeof this.page !== "undefined" ? this.page : false,
      }

      window.history.pushState(null, null, "?" + this.serialize(query))
    },
    setSelected() {
      let categories = this.findGetParameter("capes_categories")
      let order = this.findGetParameter("capes_order")
      let page = this.findGetParameter("capes_page")

      this.filters.categories = !isEmpty(categories) ? categories.split("|") : []
      this.order = order
      this.page = page
    },

    serialize(obj) {
      var str = []
      for (var p in obj)
        if (Object.hasOwn(obj, p) && obj[p]) {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]))
        }
      return str.join("&")
    },

    findGetParameter(parameterName) {
      let result = null,
        tmp = []
      let items = location.search.substr(1).split("&")
      for (var index = 0; index < items.length; index++) {
        tmp = items[index].split("=")
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
      }
      return result
    },

    gotoPage(page) {
      this.$refs.anchor.scrollIntoView({ behavior: "smooth" })
      this.page = page
      this.$events.$emit("searched")
    },
  },
}
